import { render } from "./orderPay.vue?vue&type=template&id=63ecb2fc&scoped=true"
import script from "./orderPay.vue?vue&type=script&lang=js"
export * from "./orderPay.vue?vue&type=script&lang=js"

import "./orderPay.vue?vue&type=style&index=0&id=63ecb2fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ecb2fc"]])

export default __exports__